<template>
  <b-modal ref="addUnitModal"
           id="modal-add-unit"
           title="Добавить подразделение"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-name">
        <b-form-input id="name"
                        type="text"
                        placeholder="Введите название подразделения"
                        v-model="addForm.name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-short_name">
        <b-form-input id="short_name"
                        type="text"
                        placeholder="Введите короткое название"
                        v-model="addForm.short_name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-info">
        <b-form-textarea id="info"
                        type="text"
                        placeholder="Введите подробную информацию"
                        v-model="addForm.info"
                        required>

        </b-form-textarea>
      </b-form-group>
      <b-button type="submit" variant="success">Добавить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';

export default {
  components: {
    alertMsg,
  },
  name: 'modalAdd',
  data() {
    return {
      addForm: {
        name: '',
        short_name: '',
        info: '',
      },
      alertMessage: 'Error',
      showAlert: false,
    };
  },
  computed: {
    ...mapState({
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    addItem(payload) {
      this.showAlert = false;
      const id = 'modal-add-unit';
      const path = this.host + 'add_unit';
      axios.post(path, payload, { headers: { 'Authorization': `Bearer ${localStorage.token}`, 'Content-Type': 'multipart/form-data' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('units');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = new FormData();
      payload.append('info', this.addForm.info);
      payload.append('short_name', this.addForm.short_name);
      payload.append('full_name', this.addForm.name);
      this.addItem(payload);
      this.initForm();
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-add-unit');
      this.initForm();
    },
    initForm() {
      this.addForm.short_name = '';
      this.addForm.info = '';
      this.addForm.name = '';
    },
  },
  created() {
  },
};
</script>

<style scoped>

</style>
